import React from 'react'
import { useLocation } from 'react-router-dom'
import GoBackBtn from '../../components/elements/Buttons/GoBackBtn'

function IframeView() {
  const {
    state: { link },
  } = useLocation()
  return (
    <div className='relative overflow-hidden min-w-full min-h-full'>
      <GoBackBtn />
      <iframe src={link} className='absolute inset-0 w-[100%] h-[100%]'></iframe>
    </div>
  )
}

export default IframeView